// информация о сессии – { accessToken, idToken, expires }
export const LOCAL_STORAGE_KEY_AUTH = 'auth';
// целевая страница для возвращения после успешной авторизации
export const LOCAL_STORAGE_KEY_NEXT = 'next';
